export default "__VITE_ASSET__rnIPMDoj__"